export class ListIngestionPipelinePartitionsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "partitionValue",
            "baseName": "partitionValue",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "IngestionPartitionStatusFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelinePartitionsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
